import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-8 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500 mt-1">全网最热八卦话题实时追踪</p>
          </div>
          <a href="#ranking" className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer no-underline flex items-center gap-1">
            查看完整榜单 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="flex flex-wrap gap-2.5">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href={`#cards`}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer no-underline transition-all duration-200 ${
                topic.color === 'accent'
                  ? 'bg-accent-100/70 text-accent-800 hover:bg-accent-200/80'
                  : 'bg-background-50 text-foreground-700 hover:bg-primary-50 hover:text-primary-700'
              }`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
              <span className="flex items-center gap-0.5 text-xs opacity-70">
                {topic.trend === 'hot' && <i className="ri-fire-line text-accent-500"></i>}
                {topic.trend === 'new' && <i className="ri-sparkling-line text-accent-500"></i>}
                {topic.trend === 'up' && <i className="ri-arrow-up-line text-primary-500"></i>}
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}